import axios from "axios";
const token = window.localStorage.getItem("token");
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: `${token}`
    }
};
// const baseURL = process.env.REACT_APP_API_URL;
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
export const get_all_campaign_types = async () => {
    let response = await axios.get(baseURL + "/api/campaign-types", config);
    return response.data.data;
}
export const update_campaign_types = async (campaign_type_id, name) => {
    let response = await axios.patch(baseURL + "/api/campaign-types/" + campaign_type_id, {
        "name": name,
    }, config);
    return response.data.data;
}
export const delete_campaign_type = async (campaign_type_id) => {
    let response = await axios.delete(baseURL + "/api/campaign-types/" + campaign_type_id, config);
    return response.data.data;
}